import { BuildType } from '@/services/ApiService';
import { QuerySkillParams, SkillModel } from '@/apiTypes/SkillsTypes';

export type QuerySkillsResponse = {
    rows: SkillModel[];
    count: number;
};

export type SkillsByExternalValuesResponse = {
    rows: SkillModel[];
};

export const skillApiEndpoints = (build: BuildType) => ({
    querySkills: build.query<QuerySkillsResponse, QuerySkillParams>({
        query: params => ({
            url: 'skills/query',
            method: 'POST',
            body: params,
        }),
        transformResponse: (response: QuerySkillsResponse) => response,
    }),
    // Resolves the catalog values the brainstorm workflow returns, in rank order.
    getSkillsByExternalValues: build.query<SkillsByExternalValuesResponse, string[]>({
        query: externalSourceValues => ({
            url: 'skills/by-external-values',
            method: 'POST',
            body: { externalSourceValues },
        }),
    }),
});
